export default [
    {
        name: 'originalOwner',
        transKey: 'TRADE_IN.VEHICLE_STORY.ORIGINAL_OWNER.TITLE',
        inputType: 'radio',
        options: [
            {
                transKey: 'TRADE_IN.VEHICLE_STORY.ORIGINAL_OWNER.YES',
                value: true,
            },
            {
                transKey: 'TRADE_IN.VEHICLE_STORY.ORIGINAL_OWNER.NO',
                value: false,
            },
        ],
        classNames: 'full',
    },
    {
        name: 'vehiclePurchase',
        transKey: 'TRADE_IN.VEHICLE_STORY.VEHICLE_PURCHASE.TITLE',
        inputType: 'radio',
        options: [
            {
                transKey: 'TRADE_IN.VEHICLE_STORY.VEHICLE_PURCHASE.PRIVATE',
                value: 'private',
            },
            {
                transKey: 'TRADE_IN.VEHICLE_STORY.VEHICLE_PURCHASE.DEALER',
                value: 'dealer',
            },
        ],
        classNames: 'full',
    },
    {
        name: 'vehicleCondition',
        transKey: 'TRADE_IN.VEHICLE_STORY.VEHICLE_CONDITION.TITLE',
        inputType: 'radio',
        options: [
            {
                transKey: 'TRADE_IN.VEHICLE_STORY.VEHICLE_CONDITION.PERFECT_VALUE',
                value: 'perfect',
            },
            {
                transKey: 'TRADE_IN.VEHICLE_STORY.VEHICLE_CONDITION.OK_VALUE',
                value: 'ok',
            },
            {
                transKey: 'TRADE_IN.VEHICLE_STORY.VEHICLE_CONDITION.ROUGH_VALUE',
                value: 'rough',
            },
        ],
        classNames: 'full',
    },
    {
        name: 'corporateUse',
        transKey: 'TRADE_IN.VEHICLE_STORY.CORPORATE_USE.TITLE',
        inputType: 'radio',
        options: [
            {
                transKey: 'TRADE_IN.VEHICLE_STORY.CORPORATE_USE.YES',
                value: true,
            },
            {
                transKey: 'TRADE_IN.VEHICLE_STORY.CORPORATE_USE.NO',
                value: false,
            },
        ],
        classNames: 'full',
        subQuestions: [
            {
                name: 'corporateUseExplanation',
                transKey: 'TRADE_IN.VEHICLE_STORY.CORPORATE_USE.EXPLANATION',
                inputType: 'textarea',
                classNames: 'full',
            },
        ],
    },
    {
        name: 'rustProof',
        transKey: 'TRADE_IN.VEHICLE_STORY.RUST_PROOF.TITLE',
        inputType: 'radio',
        options: [
            {
                transKey: 'TRADE_IN.VEHICLE_STORY.RUST_PROOF.YES',
                value: true,
            },
            {
                transKey: 'TRADE_IN.VEHICLE_STORY.RUST_PROOF.NO',
                value: false,
            },
        ],
        classNames: 'full',
    },
    {
        name: 'mechanicalProtection',
        transKey: 'TRADE_IN.VEHICLE_STORY.MECHANICAL_PROTECTION.TITLE',
        inputType: 'radio',
        options: [
            {
                transKey: 'TRADE_IN.VEHICLE_STORY.MECHANICAL_PROTECTION.YES',
                value: true,
            },
            {
                transKey: 'TRADE_IN.VEHICLE_STORY.MECHANICAL_PROTECTION.NO',
                value: false,
            },
        ],
        classNames: 'full',
        subQuestions: [
            {
                name: 'coverageBalance',
                transKey: 'TRADE_IN.VEHICLE_STORY.COVERAGE_BALANCE',
                inputType: 'textarea',
                classNames: 'full',
            },
        ],
    },
];
